/**
 * Preenche "Valor do orçamento" (resolution.laborValue) quando veio 0 da API.
 * Ordem de origem do valor — igual ao app (Budget/index.js totalBudgetToDisplay):
 * soma budget_items → price_service_provider → total_price_tradesman → old_tradesman_price.
 * Depois: materiais da resolução e labor_value do orçamento.
 *
 * Quando promovemos o valor para laborValue, zeramos materials[] de propósito: o formulário
 * simplificado soma materiais + mão de obra no total; manter as linhas espelhadas (ex.: app
 * que grava o mesmo valor em itens + materiais) duplicaria o envio. Resoluções que já tinham
 * laborValue > 0 não são alteradas.
 */
function materialLineTotal(material) {
  if (!material) return 0
  const total = Number(material.total)
  if (!Number.isNaN(total)) {
    return total
  }
  const unit = Number(material.unitPrice ?? material.unit_price) || 0
  const qty = Number(material.quantity) || 0
  return unit * qty
}

function sumMaterialsTotals(materials) {
  if (!materials?.length) return 0
  return materials.reduce((acc, m) => acc + materialLineTotal(m), 0)
}

function resolutionLaborValue(resolution) {
  const v = Number(resolution?.laborValue ?? resolution?.labor_value)
  return Number.isNaN(v) ? 0 : v
}

function sumBudgetItemsPrices(budget) {
  const items = budget?.budgetItems ?? budget?.budget_items ?? []
  if (!items.length) return 0
  return items.reduce((acc, i) => acc + Number(i?.price ?? 0), 0)
}

/** Mesma prioridade que o app usa para exibir o valor do orçamento. */
function valueFromBudgetLikeApp(budget) {
  const fromItems = sumBudgetItemsPrices(budget)
  if (fromItems > 0) return fromItems

  const psp = Number(budget?.priceServiceProvider ?? budget?.price_service_provider ?? 0)
  if (psp > 0) return psp

  const tpt = Number(budget?.totalPriceTradesman ?? budget?.total_price_tradesman ?? 0)
  if (tpt > 0) return tpt

  const oldPrice = Number(budget?.oldTradesmanPrice ?? budget?.old_tradesman_price ?? 0)
  if (oldPrice > 0) return oldPrice

  return 0
}

export function normalizeSimplifiedResolutionsForWebForm(resolutions, budget) {
  if (!resolutions?.length) return resolutions

  const budgetLabor = Number(budget?.laborValue ?? budget?.labor_value) || 0

  return resolutions.map(resolution => {
    if (resolutionLaborValue(resolution) > 0) {
      return resolution
    }

    let nextLabor = valueFromBudgetLikeApp(budget)
    if (!nextLabor) {
      nextLabor = sumMaterialsTotals(resolution.materials)
    }
    if (!nextLabor && resolutions.length === 1 && budgetLabor > 0) {
      nextLabor = budgetLabor
    }
    if (!nextLabor) {
      return resolution
    }

    // Ver nota no topo do arquivo: evita total duplicado (mão de obra + materiais).
    return {
      ...resolution,
      laborValue: nextLabor,
      materials: [],
    }
  })
}
